/* eslint-disable no-unused-expressions */
import MicroModal from 'micromodal';
import focusElement from 'ACCESSIBILITY/focusElement';

const selectors = {
  modal: {
    id: 'product-info-modal',
    badgeWrapper: '#pi-modal-badge',
    title: '#pi-modal-title',
    contentContainer: '#pi-modal-container',
    imageWrapper: '#pi-modal-img-wrapper',
    price: '#pi-modal-price',
    comparePrice: '#pi-modal-compare-price',
    excerptElement: '#pi-modal-excerpt',
    offsiteLinkElement: '#pi-modal-button-offsite-link',
    onsiteLinkElement: '#pi-modal-button-pdp-link',
    closeButton: '[data-micromodal-close]',
  },
  infoProductsGrid: '[data-grid-type="informational"]',
  productCard: {
    wrapper: '[data-product-type="informational"]',
    image: '.product--image img',
    badge: '.product-badge',
  },
};

let previouslyclickedProductEl; // Use to prevent duplicate content for touch events which are firing this click handler twice on touchstart

const modalController = (modalEl, infoProductsGrid) => {
  // Setup Variables
  const domElements = {
    modal: {
      titleElement: modalEl.querySelector(selectors.modal.title),
      contentContainer: modalEl.querySelector(selectors.modal.contentContainer),
      badgeWrapperElement: modalEl.querySelector(selectors.modal.badgeWrapper),
      imageWrapperElement: modalEl.querySelector(selectors.modal.imageWrapper),
      priceElement: modalEl.querySelector(selectors.modal.price),
      comparePriceElement: modalEl.querySelector(selectors.modal.comparePrice),
      excerptElement: modalEl.querySelector(selectors.modal.excerptElement),
      offsiteLinkElement: modalEl.querySelector(selectors.modal.offsiteLinkElement),
      onsiteLinkElement: modalEl.querySelector(selectors.modal.onsiteLinkElement),
      closeButtonElement: modalEl.querySelector(selectors.modal.closeButton),
    },
  };

  // Helper functions

  const getContentForModal = (productCardEl) => {
    const {
      productTitle,
      productPrice,
      productComparePrice,
      productExcerpt,
      productLink,
    } = productCardEl.dataset;
    const modalInfoObj = {
      productTitle,
      productPrice,
      productComparePrice,
      productExcerpt,
      productLink,
    };
    modalInfoObj.productLinkOffsite = undefined; // TODO determine if needed
    modalInfoObj.productImage = productCardEl
      .querySelector(selectors.productCard.image)
      .cloneNode();
    const badgeEl = productCardEl.querySelector(selectors.productCard.badge);
    // eslint-disable-next-line no-unused-expressions
    badgeEl ? (modalInfoObj.productBadge = badgeEl.cloneNode(true)) : undefined;

    return modalInfoObj;
  };

  const populateModalContent = ({
    productTitle,
    productImage,
    productBadge,
    productPrice,
    productComparePrice,
    productExcerpt,
    productLink,
    productLinkOffsite,
  }) => {
    const {
      titleElement,
      imageWrapperElement,
      badgeWrapperElement,
      priceElement,
      comparePriceElement,
      excerptElement,
      offsiteLinkElement,
      onsiteLinkElement,
    } = domElements.modal;
    focusElement(titleElement, { makeFocusable: true });
    imageWrapperElement.replaceChildren(productImage);
    productBadge
      ? badgeWrapperElement.replaceChildren(productBadge)
      : (badgeWrapperElement.innerHTML = '');
    if (titleElement && productTitle) titleElement.textContent = productTitle;
    if (excerptElement && productExcerpt) excerptElement.innerHTML = productExcerpt;
    if (priceElement && productPrice) priceElement.textContent = productPrice;
    if (productComparePrice !== 'false') comparePriceElement.textContent = productComparePrice;
    if (offsiteLinkElement && productLinkOffsite) offsiteLinkElement.href = productLinkOffsite;
    if (onsiteLinkElement && productLink) onsiteLinkElement.href = productLink;
  };

  // eslint-disable-next-line consistent-return
  const handleProductClicks = (event) => {
    const { target } = event;
    const clickedProductEl = target.closest(selectors.productCard.wrapper);
    if (!clickedProductEl) return undefined;

    event.preventDefault(); // prevent links taking user to blog post page

    // Used to prevent duplicate execution of inner logic
    // need because touch events are firing this handler twice
    const modalAlreadyUpdated = previouslyclickedProductEl === clickedProductEl;

    if (!modalAlreadyUpdated) {
      const contentForModal = getContentForModal(clickedProductEl);
      populateModalContent(contentForModal);
    }

    MicroModal.show(selectors.modal.id, {
      disableScroll: true,
      disableFocus: false,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
      debugMode: true, // set to true when in dev
    });
  };

  infoProductsGrid.addEventListener('click', handleProductClicks);
};

const productInfoModal = {
  init: () => {
    const modalEl = document.querySelector(`#${selectors.modal.id}`);
    const infoProductsGrid = document.querySelector(selectors.infoProductsGrid);
    if (!modalEl || !infoProductsGrid) return;
    modalController(modalEl, infoProductsGrid);
  },
};

export default productInfoModal;
